const t = ["Open Sans", "Roboto"].join(","), e = 400, n = 600, i = 700, o = {
  fontFamily: t,
  fontWeightMedium: n,
  display100: {
    fontFamily: t,
    fontWeight: n,
    fontSize: "48px",
    lineHeight: "64px",
    letterSpacing: "-1px",
    textTransform: "none"
  },
  display200: {
    fontFamily: t,
    fontWeight: n,
    fontSize: "40px",
    lineHeight: "56px",
    letterSpacing: "-0.5px",
    textTransform: "none"
  },
  display300: {
    fontFamily: t,
    fontWeight: n,
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "-0.5px",
    textTransform: "none"
  },
  display400: {
    fontFamily: t,
    fontWeight: n,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0px",
    textTransform: "none"
  },
  heading100: {
    fontFamily: t,
    fontWeight: e,
    fontSize: "40px",
    lineHeight: "56px",
    letterSpacing: "-0.75px",
    textTransform: "none"
  },
  heading200: {
    fontFamily: t,
    fontWeight: e,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0px",
    textTransform: "none"
  },
  heading300: {
    fontFamily: t,
    fontWeight: e,
    fontSize: "18px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    textTransform: "none"
  },
  heading400: {
    fontFamily: t,
    fontWeight: n,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    textTransform: "none"
  },
  heading500: {
    fontFamily: t,
    fontWeight: n,
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "0.5px",
    textTransform: "none"
  },
  heading600: {
    fontFamily: t,
    fontWeight: e,
    fontSize: "10px",
    lineHeight: "16px",
    letterSpacing: "1.5px",
    textTransform: "uppercase"
  },
  subtitle100: {
    fontFamily: t,
    fontWeight: e,
    fontSize: "18px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    textTransform: "none"
  },
  subtitle200: {
    fontFamily: t,
    fontWeight: e,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    textTransform: "none"
  },
  subtitle300: {
    fontFamily: t,
    fontWeight: e,
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "0.5px",
    textTransform: "none"
  },
  subtitle400: {
    fontFamily: t,
    fontWeight: e,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0.5px",
    textTransform: "none"
  },
  body100: {
    fontFamily: t,
    fontWeight: e,
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "0.5px",
    textTransform: "none"
  },
  body200: {
    fontFamily: t,
    fontWeight: e,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0.4px",
    textTransform: "none"
  },
  display1: {
    fontFamily: t,
    fontSize: "42px",
    fontWeight: 300,
    textTransform: "capitalize",
    letterSpacing: "-1px",
    lineHeight: "56px"
  },
  display2: {
    fontFamily: t,
    fontSize: "32px",
    fontWeight: 300,
    textTransform: "capitalize",
    letterSpacing: "-0.5px",
    lineHeight: "40px"
  },
  display3: {
    fontFamily: t,
    fontSize: "28px",
    fontWeight: 300,
    textTransform: "none",
    letterSpacing: "0px",
    lineHeight: "32px"
  },
  h1: {
    fontFamily: t,
    fontSize: "24px",
    fontWeight: 400,
    textTransform: "none",
    letterSpacing: "0px",
    lineHeight: "32px"
  },
  h2: {
    fontFamily: t,
    fontSize: "20px",
    fontWeight: 400,
    textTransform: "none",
    letterSpacing: "0.18px",
    lineHeight: "32px"
  },
  h3: {
    fontFamily: t,
    fontSize: "18px",
    fontWeight: 600,
    textTransform: "none",
    letterSpacing: "0.15px",
    lineHeight: "24px"
  },
  h4: {
    fontFamily: t,
    fontSize: "16px",
    fontWeight: 400,
    textTransform: "none",
    letterSpacing: "0px",
    lineHeight: "24px"
  },
  h5: {
    fontFamily: t,
    fontSize: "14px",
    fontWeight: 600,
    textTransform: "none",
    letterSpacing: "0.1px",
    lineHeight: "24px"
  },
  h6: {
    fontFamily: t,
    fontSize: "12px",
    fontWeight: 400,
    textTransform: "none",
    letterSpacing: "0.4px",
    lineHeight: "16px"
  },
  subtitle1: {
    fontFamily: t,
    fontSize: "16px",
    fontWeight: 400,
    textTransform: "none",
    letterSpacing: "0.15px",
    lineHeight: "24px"
  },
  subtitle2: {
    fontFamily: t,
    fontSize: "14px",
    // Figma says 600 fontWeight, but this looks too heavy in practice
    fontWeight: 500,
    textTransform: "none",
    letterSpacing: "0.1px",
    lineHeight: "24px"
  },
  body1: {
    fontFamily: t,
    fontSize: "14px",
    fontWeight: 400,
    letterSpacing: "0.5px",
    lineHeight: "24px"
  },
  body2: {
    fontFamily: t,
    fontSize: "12px",
    fontWeight: 400,
    letterSpacing: "0.4px",
    lineHeight: "16px"
  },
  button: {
    fontFamily: t,
    fontSize: "14px",
    fontWeight: 600,
    textTransform: "none",
    letterSpacing: "0.8px",
    lineHeight: "24px"
  },
  caption: {
    fontFamily: t,
    fontSize: "12px",
    fontWeight: 400,
    textTransform: "none",
    letterSpacing: "0.4px",
    lineHeight: "16px"
  },
  overline: {
    fontFamily: t,
    fontSize: "10px",
    fontWeight: 400,
    textTransform: "uppercase",
    letterSpacing: "1.5px",
    lineHeight: "16px"
  }
};
export {
  n as a,
  i as b,
  e as f,
  o as t
};
